import {
  isOnlyMap, canAuthMap, isAgentMap, cpSourceMap, copyrightAreaMap, isOverseaMap,
  paymentMap, canCoverMap, licenseValidMap, canLegalRightsMap, contractTypeMap,
  lyricList
} from '@/views/album/mixin.js'
export {
  CP_TYPE
} from '@/utils/constants'

const freeze = Object.freeze

export const copyrightValueDictMap = {
  isOnly: isOnlyMap,
  canAuth: canAuthMap,
  isAgent: isAgentMap,
  cpSource: cpSourceMap,
  copyrightArea: copyrightAreaMap,
  isOverseaOnly: isOverseaMap,
  paymentMode: paymentMap,
  canCover: canCoverMap,
  licenseValid: licenseValidMap,
  canLegalRights: canLegalRightsMap,
  contractType: contractTypeMap
}

export const reviewStatusMap = freeze({
  0: '未审核',
  1: '取消',
  2: '通过',
  3: '不通过',
  4: '审核中'
})

function genTitle(key, name) {
  return {
    [key]: {
      newRecord: `新增${name}`,
      modifyRecord: `变更${name}`,
      rmRecord: `删除${name}`
    }
  }
}

const fieldNameM = {
  track: {
    firstPublicTime: '首发期限',
    trackName: '歌曲名',
    transName: '歌曲翻译名',
    srcVersion: '歌曲版本（文本）',
    publicTime: '发行时间'
  },
  trackPayment: {
    paymentMode: '付费模式'
  },
  trackExtend: {
    subTitle: '歌曲副标题',
    wordAuthor: '词作者（文本）',
    musicAuthor: '曲作者（文本）'
  },
  trackCopyright: {
    isAgent: '授权关系',
    canAuth: '可否转授权',
    isOnly: '授权形式',
    copyrightArea: '授权区域',
    isOverseaOnly: '海外总代理',
    cpSource: '版权来源',
    copyrightFrom: '授权开始',
    copyrightTo: '授权结束',
    originCompanyName: '原始版权公司',
    originCpCompany: '原始版权公司',
    cpPercent: '授权份额'
  },
  ...genTitle('trackSingerList', '歌手'),
  ...genTitle('trackLyricistList', '作词人'),
  ...genTitle('trackComposerList', '作曲人'),
  ...genTitle('media', '音频'),
  ...lyricList.reduce((res, cur) => {
    res = { ...res, ...genTitle(cur.key, cur.name) }
    return res
  }, {}),

  // 专辑字段
  album: {
    albumName: '专辑名',
    displayCompanyName: '外显厂牌公司',
    albumDesc: '专辑简介',
    publicTime: '专辑发行时间'
  },
  ...genTitle('albumPhotoList', '专辑封面'),
  ...genTitle('albumSingerList', '专辑艺人'),
  // END
}
fieldNameM.trackWordCopyright = {
  ...(Object.keys(fieldNameM.trackCopyright).reduce((result, key) => {
    result[key] = `词版权-${fieldNameM.trackCopyright[key]}`

    return result
  }, {})),
  newRecord: '新增词版权',
  canCover: '可翻唱',
  licenseValid: '可维权',
  canLegalRights: '可维权',
  contractType: '签约类型'
}
fieldNameM.trackMusicCopyright = {
  ...(Object.keys(fieldNameM.trackCopyright).reduce((result, key) => {
    result[key] = `曲版权-${fieldNameM.trackCopyright[key]}`

    return result
  }, {})),
  newRecord: '新增曲版权',
  canCover: '可翻唱',
  licenseValid: '可维权',
  canLegalRights: '可维权',
  contractType: '签约类型'
}
export const fieldNameMap = freeze(fieldNameM)

export const mvFieldNameMap = freeze({
  mv: {
    firstPublicTime: '首发期限'
  },
  mvCopyright: {
    isAgent: '授权关系',
    canAuth: '可否转授权',
    isOnly: '授权形式',
    copyrightArea: '授权区域',
    isOverseaOnly: '海外总代理',
    cpSource: '版权来源',
    copyrightFrom: '授权开始',
    copyrightTo: '授权结束',
    originCompanyName: '原始版权公司',
    originCpCompany: '原始版权公司',
    cpPercent: '授权份额'
  }
})
